import { render, staticRenderFns } from "./ResourcesPage.vue?vue&type=template&id=fbbdfab8&scoped=true&"
import script from "./ResourcesPage.vue?vue&type=script&lang=js&"
export * from "./ResourcesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbdfab8",
  null
  
)

export default component.exports